/**
 * @deac 大屏配置 从大屏url参数配置是否启用长连接或增加大屏长连接轮询机制 默认长轮询
 * @param 参数名称 screenConfig
 * @argument 参数值 1: 大屏采用单纯长连接方式； 2: 大屏采用轮询；
 */
import { getUrlParam } from '@/shared/functions';
/**
 * @deac isListenLong 大屏是否启用长连接=》 true: 长连接 false: 长轮询
 */
let isListenLong = false;
/**
 * @deac addPollingMechanism 长连接是否增加轮询机制=》 true: 增加 false: 不增加
 */
let addPollingMechanism = false;
const screenConfig = getUrlParam('screenConfig');
switch (screenConfig) {
    case '1':
        isListenLong = true;
        addPollingMechanism = false;
        break;
    case '2':
        isListenLong = false;
        addPollingMechanism = false;
        break;
    default:
        isListenLong = false;
        addPollingMechanism = false;
}
export { isListenLong, addPollingMechanism };
